module.exports = __webpack_public_path__ + "img/img1.67f19418.svg";